import { render, staticRenderFns } from "./modal-trivia.vue?vue&type=template&id=7b3763e3&scoped=true&"
import script from "./modal-trivia.vue?vue&type=script&lang=js&"
export * from "./modal-trivia.vue?vue&type=script&lang=js&"
import style0 from "./modal-trivia.vue?vue&type=style&index=0&id=7b3763e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3763e3",
  null
  
)

export default component.exports